import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-enterkey-submit]';
export const PLUGIN_NAME = 'enterkeySubmit';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--trigger-event" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__enterkey-submit/index.js